var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOnlyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_3452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.183594,
    width: 30,
    height: 30,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_3452)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4687 7.80801C13.8167 8.15386 13.8185 8.71639 13.4727 9.06447L7.39102 15.1853L13.4726 21.3037C13.8185 21.6517 13.8168 22.2142 13.4688 22.5601C13.1208 22.906 12.5582 22.9043 12.2123 22.5563L5.50833 15.8117C5.16394 15.4653 5.16388 14.9057 5.50821 14.5592L12.2122 7.81205C12.558 7.46397 13.1206 7.46217 13.4687 7.80801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70414 15.1854C5.70414 14.6947 6.10191 14.297 6.59259 14.297H23.8615C24.3522 14.297 24.75 14.6947 24.75 15.1854C24.75 15.6761 24.3522 16.0739 23.8615 16.0739H6.59259C6.10191 16.0739 5.70414 15.6761 5.70414 15.1854Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnlyArrow);
export default __webpack_public_path__ + "static/media/icon_only_arrow.f76773d76864270a24bb921ca71c29f3.svg";
export { ForwardRef as ReactComponent };